var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('card-list',{attrs:{"title":"Komponen Gaji","dataUrl":"/api/v1/salary-item","dataSize":"10","dataHeaders":_vm.tHeaders,"editRoute":"/master/salary-item/add","deleteEndpoint":"/api/v1/salary-item"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }